export default __webpack_public_path__ + "static/whatIsMobile-a36186f1546f34df07cd587927eb9885.png";